import { z } from 'zod';
import { AccessRequestStatus, RoleList } from '../enums';

export const AccessRequestDto = z.object({
  id: z.string().uuid(),
  email: z.string(),
  displayName: z.string(),
  status: AccessRequestStatus,
  requestedAt: z.string(),
  lastRequestedAt: z.string(),
  lastRemindedAt: z.string().nullable(),
  decidedAt: z.string().nullable(),
  decidedByName: z.string().nullable(),
  reason: z.string().nullable(),
});
export type AccessRequestDto = z.infer<typeof AccessRequestDto>;

export const AccessRequestListQuery = z.object({
  status: AccessRequestStatus.optional(),
  limit: z.coerce.number().int().min(1).max(500).default(200),
});
export type AccessRequestListQuery = z.infer<typeof AccessRequestListQuery>;

export const ApproveAccessRequestInput = z.object({
  roles: RoleList.min(1),
});
export type ApproveAccessRequestInput = z.infer<typeof ApproveAccessRequestInput>;

export const DenyAccessRequestInput = z.object({
  reason: z.string().trim().min(1, 'Enter a reason for denying this request').max(1000),
});
export type DenyAccessRequestInput = z.infer<typeof DenyAccessRequestInput>;
